// utils/format.js
export const fmtINR = (n) => {
  const v = Number(n) || 0;
  if (v === 0) return "₹0";
  if (v >= 1e9) return `₹${(v / 1e7).toFixed(0)} Cr`;
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(2)} Cr`;
  if (v >= 1e5) return `₹${(v / 1e5).toFixed(2)} L`;
  if (v >= 1e3) return `₹${(v / 1e3).toFixed(1)} K`;
  return `₹${v.toLocaleString("en-IN")}`;
};

export const fmtINRFull = (n) =>
  `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;

export const fmtNum = (n, d = 0) =>
  Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: d, minimumFractionDigits: d });

export const fmtBps = (n) => `${Number(n || 0).toFixed(0)} bps`;

export const fmtPct = (n, d = 1) => `${(Number(n) || 0).toFixed(d)}%`;

export const fmtScore = (s) => (s == null ? "—" : Number(s).toFixed(1));

export const riskClass = (lvl) =>
  ({
    Low: "risk-pill risk-low",
    Medium: "risk-pill risk-medium",
    High: "risk-pill risk-high",
    Critical: "risk-pill risk-critical",
  }[lvl] || "risk-pill risk-medium");

export const riskColor = (lvl) =>
  ({ Low: "#2E5A35", Medium: "#8F5E14", High: "#A93226", Critical: "#4A1A1A" }[lvl] || "#6B7280");

export const HAZARD_COLORS = {
  flood: "#1E88E5",
  cyclone: "#7B1FA2",
  heat_stress: "#E64A19",
  drought: "#A0522D",
  hailstorm: "#00838F",
  lightning: "#F57F17",
  dust_storm: "#A1887F",
  extreme_rainfall: "#1565C0",
  sea_level_rise: "#0277BD",
  landslide: "#5D4037",
  wildfire: "#BF360C",
};

export const HAZARD_LABELS = {
  flood: "Flood",
  cyclone: "Cyclone",
  heat_stress: "Heat Stress",
  drought: "Drought",
  hailstorm: "Hailstorm",
  lightning: "Lightning",
  dust_storm: "Dust Storm",
  extreme_rainfall: "Extreme Rainfall",
  sea_level_rise: "Sea Level Rise",
  landslide: "Landslide",
  wildfire: "Wildfire",
};

export const fmtDateTime = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString("en-IN", {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit",
    });
  } catch { return s; }
};
